import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, AlertTitle } from '@material-ui/lab';
import { useSelector } from 'react-redux';
import { CommonRootState } from '@pec/aion-ui-core/combineReducers';
import axios from 'axios';
import { IInvoice } from '@pec/aion-ui-core/interfaces/invoice';
import { Link } from '@material-ui/core';
import { PaymentStatus } from '@pec/aion-ui-core/interfaces/subscription';

const limitDays = 5;

export const PendingPaymentAlert = () => {
  const { t } = useTranslation();
  const { mainSubscription } = useSelector((state: CommonRootState) => state.mainSubscription);
  const [invoice, setInvoice] = useState<IInvoice>();

  const diffDays = invoice?.createdAtUtc
    ? Math.floor((new Date().getTime() - new Date(invoice.createdAtUtc).getTime()) / (1000 * 60 * 60 * 24))
    : 0;

  useEffect(() => {
    if (mainSubscription.paymentStatus === PaymentStatus.Pending && mainSubscription.paymentTransactionId) {
      try {
        axios
          .get<IInvoice>(
            `/api/v1/payments/${mainSubscription.paymentTransactionId}/${mainSubscription.countryISO2}/invoice`
          )
          .then(result => setInvoice(result.data));
      } catch (e) {
        console.error(e);
      }
    }
  }, [mainSubscription]);

  if (mainSubscription.paymentStatus !== PaymentStatus.Pending || !invoice) return null;

  return (
    <Alert severity={diffDays < limitDays ? 'warning' : 'error'}>
      <AlertTitle>
        {t('pendingPayment.limitedAccess', 'You have limited access until your invoice is paid in full.')}
      </AlertTitle>
      {t(
        'pendingPayment.questionnaire',
        'You wont be able to publish your questionnaire though you can answer all questions.'
      )}{' '}
      <br />
      {t('pendingPayment.stripe', 'Here is your Stripe invoice to make payment')}:{' '}
      <Link href={invoice.invoiceUrl} target="_blank" style={{ color: 'inherit', fontWeight: 700 }}>
        {t('pendingPayment.invoice', 'Open invoice')}
      </Link>
      <br />
      {diffDays > limitDays && (
        <b>
          {t(
            'pendingPayment.cancellation',
            'Please ensure payment is made otherwise your membership will be cancelled and you would need to register again.'
          )}
        </b>
      )}
    </Alert>
  );
};
